import wos from 'apis/wos';
import cartAPI, {
  forceMigrationRefresh,
  mustForceMigrationRefresh,
  setCartGuidHeader,
} from 'apis/cart';

import type { Cart, CartMigrationDetail } from '.';
import type { CartSubmitData } from 'domains/checkout';

type CartGuidResponse = { cart_guid: string };
export type CartUpdateFields = Partial<Pick<Cart, 'color_correct' | 'reference'>>;

export const CartModel = {
  async check() {
    const resp = await wos.get<CartGuidResponse | null>('/cart.json');

    if (resp.data) {
      setCartGuidHeader(resp.data.cart_guid);
    }

    return resp.data?.cart_guid;
  },

  async get() {
    let resp = await cartAPI.get<Cart>(`/`);

    if (!resp.data.on_latest_snapshot) {
      const { data } = await cartAPI.post<CartMigrationDetail>('/migrate');
      if (mustForceMigrationRefresh(data)) {
        forceMigrationRefresh();
      }

      resp = await cartAPI.get<Cart>(`/`);
    }

    return resp.data;
  },

  async create() {
    const { data } = await wos.post<CartGuidResponse>('/carts.json');

    setCartGuidHeader(data.cart_guid);
    const resp = await cartAPI.get<Cart>(`/`);

    return resp.data;
  },

  async update<T extends CartUpdateFields>(update: T) {
    const resp = await cartAPI.patch<T>('/', update);

    return resp.data;
  },

  async submit(submitData: CartSubmitData) {
    const resp = await cartAPI.post<{ id: string }>('/submit', submitData);

    return resp.data.id;
  },
};
